import { useTranslation } from 'react-i18next'

import { clsx } from 'clsx'

import { YesIcon } from '@dfds-frontend/navigator-icons/icons'

import { ActiveSelectField, useActiveSelectField } from '../../context/ActiveSelectFieldProvider'
import { useTravelSearchContext } from '../../context/TravelSearchProvider'

const currencyOptions: {
  code: 'EUR' | 'MAD'
  labelKey: string
}[] = [
  { code: 'EUR', labelKey: 'EURO' },
  { code: 'MAD', labelKey: 'DIRHAM' },
]

const Currency: React.FC = () => {
  const { t } = useTranslation()
  const {
    dispatch,
    state: { selectedCurrency },
  } = useTravelSearchContext()
  const { closeIfActive } = useActiveSelectField()

  const handleSelect = (currency: 'EUR' | 'MAD') => {
    dispatch({ currency, type: 'SET_CURRENCY' })
    closeIfActive(ActiveSelectField.CURRENCY)
  }

  return (
    <div className="bg-semantic-global-background-white">
      <ul className="m-0 w-full list-none border-0 border-solid p-0">
        {currencyOptions.map(({ code, labelKey }) => (
          <li
            className={clsx(
              'flex h-[90px] cursor-pointer list-none items-center border-0 border-b border-solid border-b-semantic-global-border-light px-semantic-global-md',
              selectedCurrency === code
                ? 'bg-semantic-form-controls-background-ghost-pressed'
                : 'bg-semantic-global-background-white lg:hover:bg-semantic-form-controls-background-ghost-hover'
            )}
            data-e2e={`currency-${code.toLowerCase()}`}
            key={code}
            onClick={() => handleSelect(code)}
          >
            <label className="cursor-pointer font-medium text-semantic-global-text-default">{t(labelKey)}</label>
            {selectedCurrency === code ? (
              <div className="ml-auto text-semantic-global-text-default">
                <YesIcon size="md" />
              </div>
            ) : null}
          </li>
        ))}
      </ul>
    </div>
  )
}

export default Currency
